import React from "react";
import { useTranslation } from "react-i18next";

export default function RefundDeleteModal({label, deleteUser,cancelRequest, id ,btnLabel}) {
  const { t } = useTranslation("components");
  return (
    <div className="confirm-delete-wrapper register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>{label}</h3>
              <div className="confirm-btn-box">
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  {t("confirmModal.no")}
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={()=>deleteUser(id)}
                >
                 {t("confirmModal.yes")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
